import React from 'react';
import { ImageIcon } from 'lucide-react';
type CoverImageProps = {
  src?: string;
  alt: string;
  title: string;
  label: string;
  className?: string;
  compact?: boolean;
};
export function CoverImage({
  src,
  alt,
  title,
  label,
  className = '',
  compact = false
}: CoverImageProps) {
  if (src) {
    return <img src={src} alt={alt} className={`aspect-[3/4] w-full rounded-md object-cover ${className}`} data-id="element-53" data-mp="2xirgtlmjlue7" />;
  }
  return <div role="img" aria-label={alt} className={`relative flex aspect-[3/4] w-full flex-col overflow-hidden rounded-md bg-espresso-2 ${compact ? 'p-1.5' : 'p-3 sm:p-4'} ${className}`} data-id="element-54" data-mp="2sjoggehiccck">
      <span className={`text-center font-display uppercase tracking-wider text-ivory ${compact ? 'text-[7px]' : 'text-[11px] sm:text-sm'}`} data-id="element-55" data-mp="2jkb3hbu6d5n3">
        Flauto <span className="text-wood" data-id="element-56" data-mp="hqbuix4iz0dk">Master</span>
      </span>
      <div className={`flex flex-1 flex-col justify-center ${compact ? 'py-1' : 'py-3'}`} data-id="element-57" data-mp="crhaxsyqh7se">
        <div className={`rounded-sm bg-ivory text-center ${compact ? 'px-1 py-1' : 'px-2 py-2.5'}`} data-id="element-58" data-mp="bqujrtoofuzs">
          <span className={`block font-display uppercase leading-tight text-espresso ${compact ? 'text-[8px]' : 'text-sm sm:text-lg'}`} data-id="element-59" data-mp="gqyt8zr63pgi">
            {title}
          </span>
        </div>
        <span className={`mt-1.5 block text-center font-semibold uppercase tracking-wider text-wood ${compact ? 'text-[6px]' : 'text-[9px] sm:text-[11px]'}`} data-id="element-60" data-mp="7qammq43srdn">
          {label}
        </span>
      </div>
      <span className={`flex items-center justify-center gap-1 text-sand ${compact ? 'text-[6px]' : 'text-[10px]'}`} data-id="element-61" data-mp="lps56nqt38ek">
        <ImageIcon className={compact ? 'h-2 w-2' : 'h-3 w-3'} aria-hidden="true" data-id="element-62" data-mp="qnle3ojhugij" />
        Copertina
      </span>
    </div>;
}